import styled, { css } from 'styled-components';

import { IBasicStyledProps, theme } from '@notino/react-styleguide';
interface IDisabledText extends IBasicStyledProps {
  disabled: boolean;
}

export const Container = styled.div<{ newPdDesignEnabled: boolean }>`
  padding: 1rem 0;
  display: block;

  label {
    ${({ newPdDesignEnabled }) =>
      newPdDesignEnabled
        ? theme.typography.labelRegular
        : css`
            font-weight: 700;
          `}
  }

  svg {
    vertical-align: middle;
    padding-left: 0.4rem;
  }
`;

export const TooltipWrapper = styled.div`
  text-align: left !important;
  font-size: 0.9rem;
  padding: 0.2rem;
`;

export const Description = styled.div<{ newDesign: boolean }>`
  padding-left: 2.25rem;
  a {
    text-decoration: underline;
  }
  a:hover {
    cursor: pointer;
  }

  ${({ newDesign }) =>
    newDesign
      ? css`
          margin-top: 0.25rem;
          color: ${theme.color.text.secondary};
          ${theme.typography.bodyRegular}
        `
      : css`
          line-height: 1.313rem;
          font-size: 0.875rem;

          a {
            color: ${theme.color.text.primary};
          }
        `}
`;

export const DisabledTextWrapper = styled.div`
  color: ${(props: IDisabledText) =>
    props.disabled
      ? props.theme.color.text.disabled
      : props.theme.color.text.primary};
`;
